module.exports = __webpack_public_path__ + "img/platzhalter-chiba-kat.a077ffc0.jpg";